// rd.service.ts


/*Need to revert the change the check of RD Service before Deployment*/
export { };
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, from, of, throwError, timer } from 'rxjs';
import { catchError, delay, filter, map, retryWhen, scan, switchMap, take, timeout } from 'rxjs/operators';
import { rdResponse, rdSearchResponse, SurveyInfo } from '../models/rd-models';
import { asQueryString } from '../models/user-params-models';
import { DeviceDetectorService } from './device-detector.service';
import { environment } from 'src/environments/environment';
declare global {
  interface Window {
    pass_params: () => string;
    to_object: (input: string) => any;
  }
}

@Injectable({
  providedIn: 'root'
})

export class RdService {
  baseUrl = environment.baseUrl;
  // baseUrl='http://localhost:65229/';
  // baseUrl = 'http://localhost:65230/';
  ScripQ_VendorAns:any[]=[];
  // baseUrl = 'https://apisurvey2.opinionest.com/'
  // baseUrl='https://adminapibetaangular.opinionest.com/';
  private rdInfoCheckApiUrl = `${this.baseUrl}RD/getInfoForRDSecurityCheck`;
  private getStandardLink = `${this.baseUrl}RD/GetStandardSurveyLink`;
  private getRedirectionLinkAfterQualify = `${this.baseUrl}Screener/GetRedirectLinkOnQuotaCheck`;
  private surveyQueryLogUrl = `${this.baseUrl}RD/SurveyQueryLog`;
  // private rdInfoCheckApiUrl = 'https://survay.opinionest.com/RD/getInfoForRDSecurityCheck';
  // private rdInfoCheckApiUrl = 'https://angular.opinionest.com/RD/getInfoForRDSecurityCheck';
  //private rdInfoCheckApiUrl = 'https://apisurvey2.opinionest.com/RD/getInfoForRDSecurityCheck';
  private publishableKey = '54456ea9-5860-436a-875a-ca5644e823b8';
  private searchEndpoint = 'https://prod.rtymgt.com/api/v4/respondents/search/';
  rd_Response: rdResponse;
  RdResponsedone: boolean = false;
  isProcessing: boolean = false; // Track if processing is happening
  doRedirect:boolean;
  statusCode:number;
  onRdScriptRetry: (() => void) | null = null;

  constructor(private deviceDetector: DeviceDetectorService, private http: HttpClient) {
  }


  getData(url: any): Observable<HttpResponse<any>> {
    return this.http.get<any>(url);
  }
  postData(obj: any, url: any): Observable<HttpResponse<any>> {
    return this.http.post<any>(url, obj, { observe: "response" });
  }

  /** Logs landing URL query params on every page load. Retries transient/http-0 failures. */
  logSurveyQuery(queryParams: { [key: string]: any }): Observable<any> {
    return this.http.get(this.surveyQueryLogUrl, { params: this.toSurveyQueryParams(queryParams) }).pipe(
      retryWhen(errors => errors.pipe(
        scan((attempt, err) => {
          if (attempt >= 2) {
            throw err;
          }
          return attempt + 1;
        }, 0),
        delay(400)
      ))
    );
  }

  surveyQueryLogFullUrl(queryParams: { [key: string]: any }): string {
    const params = this.toSurveyQueryParams(queryParams);
    const qs = params.toString();
    return qs ? `${this.surveyQueryLogUrl}?${qs}` : this.surveyQueryLogUrl;
  }

  private toSurveyQueryParams(queryParams: { [key: string]: any }): HttpParams {
    let params = new HttpParams();
    Object.keys(queryParams || {}).forEach(key => {
      const value = queryParams[key];
      if (value !== undefined && value !== null) {
        params = params.set(key, asQueryString(value, ''));
      }
    });
    return params;
  }

  toObject(response: any): rdResponse {
    console.log("rdResponse", this.rd_Response);
    return {
      rdSearch: {
        Surveys: response.rdSearch == undefined ? response.Surveys : response.rdSearch.Surveys,
        Respondent: response.rdSearch == undefined ? response.Respondent : response.rdSearch.Respondent
      },
      activityToken: response.activityToken,
      // serviceType: 2,
      serviceType: response.surveyInfo?.serviceType, // fraud detection service type
      surveyInfo: response.surveyInfo,
      queryParams: this.ScripQ_VendorAns
    };
  }




  async getPromiseData(object: any): Promise<any> {
    try {
      const response = await object.toPromise().then((r: any) => {
        return r
      });

      return response; // Return the object after inserting data
    } catch (error) {
      console.error('Error:', error);
      throw error; // Throw the error to handle it in the caller method
    }
  }
  //infoForRdSecurity
  getInfoForRDSecurityCheck(tforid: string, utype: string): Observable<any> {
    const deviceType = this.deviceDetector.getDeviceType();
    const payload = {
      "tforid": tforid,
      "utype": utype,
      "qparm": "shivam",
      "rcid": "0",
      "mode": "Live",
      "ip": " ",
      "devicetype": deviceType
    };
    return this.http.post(this.rdInfoCheckApiUrl, payload, {
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });
  }
  getRdInfoUrl(): string {
    // Return the API URL for RD info check
    // return 'https://apisurvey2.opinionest.com/RD/getInfoForRDSecurityCheck';
    return `${this.baseUrl}RD/getInfoForRDSecurityCheck`;
    // return 'https://survay.opinionest.com/RD/getInfoForRDSecurityCheck';
    // return 'https://angular.opinionest.com/RD/getInfoForRDSecurityCheck';

  }
  getStartUrl(): string {
    // Return the API URL for starting the survey
    //return 'https://apisurvey2.opinionest.com/start';
    return `${this.baseUrl}start`;
    // return 'https://survay.opinionest.com/start';
    // return 'https://angular.opinionest.com/start';

  }
  getSurveyCallBackUrl(): string {
    //return 'https://apisurvey2.opinionest.com/callbacks/Feedback';
    return `${this.baseUrl}callbacks/Feedback`;
    // return 'https://survay.opinionest.com/callbacks/Feedback';
    // return 'https://angular.opinionest.com/callbacks/Feedback';

  }

  getDropoutCallbackUrl(): string {
    return `${this.baseUrl}callbacks/Dropout`;
  }

  getSurveyUserTempDataSaveUrl(): string {
    // Return the API URL for RD info check
    // return 'https://apisurvey2.opinionest.com/RD/saveSurveyTempData';
    return `${this.baseUrl}RD/saveSurveyTempData`;
    // return 'https://survay.opinionest.com/RD/saveSurveyTempData';
    // return 'https://angular.opinionest.com/RD/saveSurveyTempData';

  }

  getSurveyStandardLink(NewParam): Observable<any> {
    return this.http.post(this.getStandardLink, NewParam, {
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });
  }

  getAfterQualifyURL(): string {
    return this.getRedirectionLinkAfterQualify;
  }

  //for new service

  // searchRespondents(surveyNumber: string, country: string, surveySession: string, doCheckSearch: number): Observable<rdResponse> {
  //   if (doCheckSearch == 1) {
  //     const endpoint = `${this.searchEndpoint}${this.publishableKey}?sn_ud=${surveySession}&wd=1&sy_nr=${surveyNumber}&coordinates=1&usage_type=1&rt_cy_ce=${country}`;

  //     return this.http.get<rdResponse>(endpoint, { withCredentials: true }).pipe(
  //       map(response => this.toObject(response))
  //     );
  //   } else {
  //     return of(this.rd_Response);
  //   }
  // }

  loadAndFetchTrackingData(surveyNumber: string, country: string, surveySession: string, doCheckSearch: number): Observable<rdResponse> {
    if (doCheckSearch == 1) {
      return this.pollPassParams().pipe(
        catchError(() => {
          if (this.onRdScriptRetry) {
            this.onRdScriptRetry();
          }
          const reload = (window as any).__oeLoadRdScript;
          const loading = typeof reload === 'function'
            ? Promise.resolve(reload()).catch(() => null)
            : Promise.resolve(null);
          return from(loading).pipe(switchMap(() => this.pollPassParams()));
        }),
        switchMap(passParamsQuery => {
          let rdSearchEndpoint = `https://prod.rtymgt.com/api/v4/respondents/search/${this.publishableKey}`;
          rdSearchEndpoint += `?sy_nr=${surveyNumber}&sn_ud=${surveySession}&wd=1&coordinates=1&usage_type=1&rt_cy_ce=${country}`;
          rdSearchEndpoint += `&${passParamsQuery}`;
          return this.http.get<rdResponse>(rdSearchEndpoint, { withCredentials: true }).pipe(
            map(response => this.toObject(response))
          );
        })
      );
    } else {
      return of(this.rd_Response);
    }
  }

  /** Ready only when pass_params() returns a non-empty string. One automatic reload if the first wait fails. */
  private passParamsValue(): string {
    try {
      const fn = (window as any).pass_params;
      if (typeof fn !== 'function') {
        return '';
      }
      return String(fn() || '').trim();
    } catch {
      return '';
    }
  }

  private pollPassParams(maxWaitMs = 5000): Observable<string> {
    const existing = this.passParamsValue();
    if (existing) {
      return of(existing);
    }
    return timer(0, 100).pipe(
      map(() => this.passParamsValue()),
      filter(value => value.length > 0),
      take(1),
      timeout(maxWaitMs),
      catchError(() => throwError(new Error('pass_params is not available on window')))
    );
  }


  verisouldCheck(data: any): Observable<HttpResponse<any>> {
    const url = `${this.baseUrl}Verisoul`
    return this.http.post<any>(url, data, { observe: "response" });
  }


  bureauCheck(data: any): Observable<HttpResponse<any>> {
    const url = `${this.baseUrl}Bureau/check`
    return this.http.post<any>(url, data, { observe: "response" });
  }

  bureauBehaviouralCheck(data: any): Observable<HttpResponse<any>> {
    const url = `${this.baseUrl}Bureau/behaviouralCheck`
    return this.http.post<any>(url, data, { observe: "response" });
  }

  getServiceType(): string {
    return `${this.baseUrl}RD/getServiceTypeForSecurityCheck`;
  }

}
